'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  color: _propTypes2.default.string
};

var defaultProps = {
  color: _colors2.default.icons
};

var displayName = 'IconBriefcase';

var IconBriefcase = function IconBriefcase(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'm4.60275 8.284-.0795.0795v10.2315l.0795.0795h14.65725l.07875-.0795v-10.2315l-.07875-.0795zm14.65725 11.8905h-14.65725c-.87 0-1.5795-.70875-1.5795-1.5795v-10.2315c0-.87075.7095-1.5795 1.5795-1.5795h14.65725c.8715 0 1.57875.70875 1.57875 1.5795v10.2315c0 .87075-.70725 1.5795-1.57875 1.5795z', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm14.9385 8.2135c-.41475 0-.75-.336-.75-.75v-1.86675l-.08025-.0795h-4.35525l-.0795.0795v1.86675c0 .414-.33525.75-.75.75-.414 0-.75-.336-.75-.75v-1.86675c0-.87075.7095-1.5795 1.5795-1.5795h4.35525c.8715 0 1.58025.70875 1.58025 1.5795v1.86675c0 .414-.33525.75-.75.75', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm10.3065 12.8155h-6.22275c-.20625 0-.375-.16725-.375-.375 0-.207.16875-.375.375-.375h6.22275c.2085 0 .375.168.375.375 0 .20775-.1665.375-.375.375', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm19.51875 12.8155h-6.222c-.207 0-.375-.16725-.375-.375 0-.207.168-.375.375-.375h6.222c.2085 0 .375.168.375.375 0 .20775-.1665.375-.375.375', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm11.26875 14.14h1.3245v-2.361h-1.3245zm1.6995.75h-2.0745c-.20625 0-.375-.168-.375-.375v-3.111c0-.20775.16875-.375.375-.375h2.0745c.20775 0 .375.16725.375.375v3.111c0 .207-.16725.375-.375.375z', fill: color }),
    ' '
  );
};

IconBriefcase.propTypes = propTypes;
IconBriefcase.defaultProps = defaultProps;
IconBriefcase.displayName = displayName;

exports.default = IconBriefcase;
module.exports = exports.default;